import { X } from "lucide-react";
import * as React from "react";
import { useRef } from "react";

type Props = {
  id?: string;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  autoFocus?: boolean;
  // Further attributes for the input, as a combobox wires it to its list.
  inputProps?: React.InputHTMLAttributes<HTMLInputElement>;
};

const SearchInput: React.FC<Props> = ({
  id,
  value,
  onChange,
  placeholder,
  autoFocus,
  inputProps,
}) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const clear = () => {
    onChange("");
    inputRef.current?.focus();
  };

  return (
    <div className="search-field">
      <input
        {...inputProps}
        ref={inputRef}
        id={id}
        className="search"
        placeholder={placeholder}
        // oxlint-disable-next-line jsx-a11y/no-autofocus -- only as its caller asks, when the user has just opened what it's in (the quick log, the add form)
        autoFocus={autoFocus}
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
      {value && (
        <button
          type="button"
          className="search-clear"
          aria-label="Clear search"
          onClick={clear}
        >
          <X size="1em" aria-hidden="true" />
        </button>
      )}
    </div>
  );
};

export default SearchInput;
